import { BASE_API_URL_CAP_DIEN } from "@utils/constants";

export const APIDongBoTiepNhanYeuCau = {
  SYNC_TIEP_NHAN_YEU_CAU: `${BASE_API_URL_CAP_DIEN}/tiep-nhan-yeu-cau/sync`,
};
